import { useQuery } from '@tanstack/react-query';
import { useLatestLoan } from '@/hooks/webapi';
import useError from '@/hooks/useError';
import fetchData from '@/utils/fetchData';
import useSmartlook from '@/hooks/useSmartlook';

export type WithdrawDataDatetype = { withdrawalDate: string };

export function useWithdrawQuery() {
  const { showError } = useError();
  const { error } = useSmartlook();
  const { latestLoan } = useLatestLoan();

  return useQuery<WithdrawDataDatetype>({
    queryKey: ['client', 'contract', 'withdraw'],
    queryFn: async () => {
      try {
        const resp = await fetchData('/client/contract/withdraw');

        return resp;
      } catch (e) {
        error('[useWithdrawQuery][GET /client/contract/withdraw]', e);
        showError();
        throw e;
      }
    },
    staleTime: Infinity,
    enabled: Boolean(latestLoan),
  });
}
